import script from "./ScreenSlide.vue?vue&type=script&lang=ts&setup=true"
export * from "./ScreenSlide.vue?vue&type=script&lang=ts&setup=true"

import "./ScreenSlide.vue?vue&type=style&index=0&id=016af5da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-016af5da"]])

export default __exports__